import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { getPaymentProcessorTypeDisplay, PaymentProcessorConnection } from '../../../../../../models/organization-config';

import { AccountService } from '../../../../../../services/account/account.service';
import { OrganizationConfigService } from '../../../../../../services/organization-config/organization-config.service';

import { CallbackResult } from '../../../../../../utils';
import { CurrencyField, PaymentProcessorType } from '../../../../../../models/organization-config-enums';


@Component({
  selector: 'app-configure-payment-processor-connection',
  templateUrl: './configure-payment-processor-connection.component.html',
  styleUrls: ['./configure-payment-processor-connection.component.css']
})
export class ConfigurePaymentProcessorConnectionComponent implements OnInit {

  public conn: PaymentProcessorConnection;
  public originalConnName: string;

  public loadingConn = true;
  public loadingEdit = false;

  public connNotFound = false;
  public serverError: number = null;

  public successMessage = '';
  public errorMessage = '';
  public errors: any = {};

  public modalResult: CallbackResult = null;

  public PaymentProcessorType = PaymentProcessorType;
  public getPaymentProcessorTypeDisplay = getPaymentProcessorTypeDisplay;

  // Counters tracking the number of requests. Used to determine if a given
  // request is the last outstanding one of its type, which in turn determines
  // when loading indicators may be removed and data may be updated.
  private requestCount = 0;

  constructor(
    private route: ActivatedRoute,
    private accountService: AccountService,
    private orgConfigService: OrganizationConfigService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().is_organization_admin) {
      return;
    }

    const routeParams = this.route.snapshot.params;

    const connId = parseInt(routeParams.id, 10);
    if (isNaN(connId)) {
      this.connNotFound = true;
      return;
    }

    this.loadConn(connId);
  }

  public saveConn() {
    this.loadingEdit = true;

    this.successMessage = '';

    this.requestCount++;

    const thisRequestCount = this.requestCount;

    this.orgConfigService
      .updatePaymentProcessorConnection(this.conn)
      .then(response => {
        // Update the local org config if there are no other org config requests in progress.
        if (thisRequestCount === this.requestCount) {
          this.conn = response;
          this.originalConnName = this.conn.name;
          this.successMessage = 'Changes saved successfully.';
        }
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to update this configuration value.';
        } else if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please fix the errors shown and try again.';
        } else {
          this.errorMessage = 'Error updating config: ' + reason.status.toString();
        }
      })
      .finally(() => {
        if (thisRequestCount === this.requestCount) {
          this.loadingEdit = false;
        }
      });
  }

  public bankAccountOptionAvailable() {
    return (
      [
        PaymentProcessorType.stripe,
        PaymentProcessorType.gravity
      ].includes(this.conn.payment_processor) &&
      (this.orgConfigService.getOrganizationConfig().currency !== CurrencyField.thb)
    );
  }

  private loadConn(connId: number) {
    this.loadingConn = true;

    this.orgConfigService
      .getPaymentProcessorConnection(connId)
      .then(result => {
        this.conn = result;
        this.originalConnName = this.conn.name;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else if (reason.status === 404) {
          this.connNotFound = true;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => {
        this.loadingConn = false;
      });
  }

}
